import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-upload-req-job-profile-modal',
  templateUrl: './upload-req-job-profile-modal.component.html'
})
export class UploadReqJobProfileModalComponent {

  modalData: any = {};

  constructor(private bsModalRef: BsModalRef, private bsModalService: BsModalService) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
